import { h as head, e as escape_html, b as attr, c as attr_class, f as clsx, p as pop, a as push } from "../../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../../chunks/exports.js";
import "../../../../chunks/utils.js";
import "../../../../chunks/state.svelte.js";
import { g as getToastState } from "../../../../chunks/Toast.svelte.js";
import { e as eyeSlash } from "../../../../chunks/icons.js";
import { h as html } from "../../../../chunks/html.js";
function _page($$payload, $$props) {
  push();
  getToastState();
  let { data, form } = $$props;
  let password = "";
  let confirmPassword = "";
  let formErrors = {};
  head($$payload, ($$payload2) => {
    $$payload2.title = `<title>Reset Password</title>`;
  });
  if (data.status === 200) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<h2 class="text-center text-2xl font-bold">Reset Password</h2> <p class="mt-2 text-center text-sm text-gray-800">Enter your new password below.</p> <form method="POST" class="mt-4 space-y-3">`);
    if (formErrors._errors) {
      $$payload.out.push("<!--[-->");
      $$payload.out.push(`<div class="mb-4 rounded-md bg-red-50 p-4" role="alert"><p class="text-sm text-red-700">${escape_html(formErrors._errors[0])}</p></div>`);
    } else {
      $$payload.out.push("<!--[!-->");
    }
    $$payload.out.push(`<!--]--> <div class="group relative"><label for="password" class="block text-sm font-semibold">Password <span class="text-red-500">*</span></label> <input${attr("type", "password")} id="password" name="password"${attr_class(clsx({
      "focus:border-primary w-full rounded-md border-2 border-black p-2 focus:outline-none": true,
      "border-red-500": !!formErrors.password
    }))}${attr("value", password)} required/> <button type="button" class="absolute top-7 right-3 text-xs text-gray-700" tabindex="-1">`);
    {
      $$payload.out.push("<!--[!-->");
      $$payload.out.push(`${html(eyeSlash)}`);
    }
    $$payload.out.push(`<!--]--></button></div> <div class="group relative"><label for="confirmPassword" class="block text-sm font-semibold">Confirm Password <span class="text-red-500">*</span></label> <input${attr("type", "password")} id="confirmPassword" name="confirmPassword"${attr_class(clsx({
      "focus:border-primary w-full rounded-md border-2 border-black p-2 focus:outline-none": true,
      "border-red-500": !!formErrors.confirmPassword
    }))}${attr("value", confirmPassword)} required/> <button type="button" class="absolute top-7 right-3 text-xs text-gray-700" tabindex="-1">`);
    {
      $$payload.out.push("<!--[!-->");
      $$payload.out.push(`${html(eyeSlash)}`);
    }
    $$payload.out.push(`<!--]--></button> `);
    if (formErrors.confirmPassword) {
      $$payload.out.push("<!--[-->");
      $$payload.out.push(`<p class="mt-1 text-xs text-red-600">${escape_html(formErrors.confirmPassword[0])}</p>`);
    } else {
      $$payload.out.push("<!--[!-->");
    }
    $$payload.out.push(`<!--]--></div> <input type="hidden" name="token"${attr("value", data.token)}/> <button type="submit" class="bg-primary hover:bg-primary/90 group flex w-full items-center justify-center rounded-md p-2 text-white transition-colors">`);
    {
      $$payload.out.push("<!--[!-->");
    }
    $$payload.out.push(`<!--]--> Reset Password</button></form>`);
  } else {
    $$payload.out.push("<!--[!-->");
    if (data.status === 400) {
      $$payload.out.push("<!--[-->");
      $$payload.out.push(`<div class="text-center"><h2 class="text-2xl font-bold">Reset Password</h2> <p class="mt-2 font-bold text-gray-500">${escape_html(data.error)}</p></div>`);
    } else {
      $$payload.out.push("<!--[!-->");
      $$payload.out.push(`<div class="text-center"><h2 class="text-2xl font-bold">Reset Password</h2> <p class="mt-2 font-bold text-gray-500">Invalid or expired token</p></div>`);
    }
    $$payload.out.push(`<!--]-->`);
  }
  $$payload.out.push(`<!--]-->`);
  pop();
}
export {
  _page as default
};
